<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <b-card-group>
          <!-- 🔹 First: Render user block -->
          <b-media
            v-if="userEntry"
            right-align
            vertical-align="center"
            class="w-100"
          >
            <h5 class="mt-0 mb-1 text-capitalize">
              <strong>Name :</strong> {{ userEntry[1].name }}
            </h5>
            <h5 class="mt-0 mb-1 text-capitalize">
              <strong>Joined At :</strong> {{ userEntry[1].joined_at }}
            </h5>
          </b-media>

          <div
            v-for="(entry, index) in ceEntries"
            :key="index"
            class="p-1"
            style="max-width: 20rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ entry[0].replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                {{ entry[1].status }}
              </p>
            </b-media>
          </div>

          <div
            v-if="evaluatorEntry"
            class="p-1"
            style="max-width: 20rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ evaluatorEntry[0].replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                {{ evaluatorEntry[1].name }}
              </p>
            </b-media>
          </div>
          <div
            v-if="productEntry"
            class="p-1"
            style="max-width: 20rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ productEntry[0].replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                {{ productEntry[1] }}
              </p>
            </b-media>
          </div>
          <div
            v-if="createdAtEntries"
            class="p-1"
            style="max-width: 20rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ createdAtEntries[0].replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                {{ createdAtEntries[1] }}
              </p>
            </b-media>
          </div>
          <div
            v-if="certificateCategoryEntries"
            class="p-1"
            style="max-width: 40rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ certificateCategoryEntries[0].replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                <strong>name:</strong> {{ certificateCategoryEntries[1].name }}
              </p>
              <p>
                <strong>Schema Owner:</strong> {{ certificateCategoryEntries[1].schema_owner.join(', ') }}
              </p>
            </b-media>
          </div>
          <!-- 🔹 Second: Render all other filtered entries -->
          <div
            v-for="([key, value]) in otherEntries"
            :key="key"
            class="p-1"
            style="max-width: 20rem;"
          >
            <b-media
              right-align
              vertical-align="center"
            >
              <h5 class="mt-0 mb-1 text-capitalize">
                {{ key.replaceAll('_', ' ') }} :
              </h5>
              <p class="mb-0">
                {{ value }}
              </p>
            </b-media>
          </div>
        </b-card-group>
      </b-col>

      <b-col
        cols="12"
        md="12"
      >
        <PersonnelAuditAndtrainigTables
          :open-evaluation-id="$route.params.id"
          @evaluation-details="evaluationDetails"
        />

        <PersonnelEvaluationFiles
          :evaluation-id="$route.params.id"
          :evaluation="rawEvaluation"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import PersonnelAuditAndtrainigTables from '../personnel-components/PersonnelAuditAndtrainigTables.vue'
import PersonnelEvaluationFiles from '../personnel-components/PersonnelEvaluationFiles.vue'

export default {
  components: { PersonnelAuditAndtrainigTables, PersonnelEvaluationFiles },
  data() {
    return {
      // The evaluation as received, kept alongside the entries list because the attachments and
      // allocation-approval panel needs the object itself, not Object.entries() of it.
      rawEvaluation: {},
      personnalDetails: {},
      dataToShow: ['user', 'ce_level_before', 'ce_level_after', 'conclusion', 'personnel_evaluation_remarks', 'next_evaluation_date', 'evaluator', 'certificate_category'],
    }
  },
  computed: {
    userEntry() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'user')
        : null
    },
    ceBeforeEntry() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'ce_level_before')
        : null
    },
    ceAfterEntry() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'ce_level_after')
        : null
    },
    evaluatorEntry() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'evaluator')
        : null
    },
    productEntry() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'product')
        : null
    },
    ceEntries() {
      const entries = []
      if (this.ceBeforeEntry) entries.push(this.ceBeforeEntry)
      if (this.ceAfterEntry) entries.push(this.ceAfterEntry)
      return entries
    },
    certificateCategoryEntries() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.find(([key]) => key === 'certificate_category')
        : null
    },
    createdAtEntries() {
      if (!Array.isArray(this.personnalDetails)) return null

      const entry = this.personnalDetails.find(([key]) => key === 'created_at')
      if (!entry) return null

      const rawDate = entry[1]
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).format(new Date(rawDate))

      return ['evaluation_date', formattedDate]
    },

    otherEntries() {
      return Array.isArray(this.personnalDetails)
        ? this.personnalDetails.filter(
          ([key, value]) => this.dataToShow.includes(key)
            && key !== 'user'
            && key !== 'ce_level_before'
            && key !== 'ce_level_after'
            && key !== 'evaluator'
            && key !== 'certificate_category'
            && value !== null
            && value !== undefined
            && value !== '',
        )
        : []
    },
  },
  methods: {
    evaluationDetails(data) {
      this.rawEvaluation = data || {}
      this.personnalDetails = Object.entries(data)
    },
  },
}
</script>
